import store from "../store";
const color = "#fff";


export default {
  innerContent: [],
  emptyInnerContent() {
    this.innerContent = []
  },
  pushToInnerContent(someRowContent) {
    this.innerContent.push(someRowContent)
  },
  getDocumentDefinition( pageOrientation = 'portrait') {
    const content = []
       this.innerContent.push({
        text: `\n\n created with BitsEMS [076 243 9441]`,
        alignment: "center",
        pageBreak: "after",
      });
      
    content.push(this.innerContent);
    return {  pageOrientation ,content };
  },
  companyHeader(textTitle) {
    return [
      {
        style: [this.getPdfStyles().tableMainHeaderStyle],
        table: {
          widths: ["60%", "40%"],
          body: [
            [
              {
                text: textTitle,
                style: [this.getPdfStyles().header],
                alignment: "left",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: store.getters.getUserSchool.schname,
                style: [this.getPdfStyles().subHeader],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: store.getters.getUserSchool.physical_address,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: `${store.getters.getUserSchool.city}, ${store.getters.getUserSchool.pcode}`,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: store.getters.getUserSchool.sch_tel,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: 'admin@'+store.getters.getUserSchool.domain+'.com',
                style: [this.getPdfStyles().email, this.getPdfStyles().italics],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
          ],
        },
      },
      this.myCustomMarginHeaderBottom(),
    ];
  },

  createTable(headersArray, rowsArray, headersBorder = [true, true, true, true], rowsBorder = [true, true, true, true]) {
    const percent = (100 / headersArray.length).toFixed(0)
    
    const wids = []
    headersArray.forEach(() => {
      wids.push( percent + "%" )
    })
    
    return {
      table: {
        heights: 15,
        widths: wids,
				body: [
					this.tableHeader(headersArray,headersBorder),
          ...this.tableRows(headersArray, rowsArray,rowsBorder),
          [{
            
							colSpan: headersArray.length,
							text: '',
							border: [false, false, false, false]
					}]
				]
      },
      layout: {
				fillColor: function (rowIndex) {
					return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
				}
			}
		}
  },


  tableHeader(headersArray,headersBorder) {
    const headers = [];
    if (headersArray.length > 0) {

        headersArray.forEach((header) => {
                const headerColumn = {
                          border: headersBorder,
                          fillColor: store.getters.getThemeColor,
                          color,
                          text: `${header.text}`,
                          alignment: "left",
                          style: [this.getPdfStyles().addressSection],
                }
          
          headers.push(headerColumn)
        });
     } 
      return headers;
  },
  tableRows(headersArray, rowsArray,rowsBorder) {
     const rows = [];
    if (rowsArray.length > 0) {
      rowsArray.forEach((columnsArray) => {
        const oneRowArray = []
        headersArray.forEach(columnHeader => {
          oneRowArray.push({
             border: rowsBorder,
              text: `${columnsArray[columnHeader.value]}`,
                 alignment: 'left'
            
          })
        })
        rows.push(oneRowArray)
          
        
      })
    }
    return rows;
  },
  dateAndPersonalInfo(client, invoiceDate, invoiceNumber) {
    return {
      style: [this.getPdfStyles().totalsPane],
      table: {
        widths: ["40%", "*", "*", "40%"],
        body: [
          [
            {
              border: [false, false, false, true],
              fillColor: store.getters.getThemeColor,
              color,
              text: `Name: ${client.name}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: store.getters.getThemeColor,
              color,
              text: `Position: ${client.position || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Reference: ${client.client_reference}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Institution: ${client.institution || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Address: ${client.address}. ${client.city}, ${client.postal_code}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Date: ${invoiceDate} \n Invoice #: ${invoiceNumber}`,
            },
          ],
        ],
      },
    };
  },
  header(text , align = 'center') { 
    return {
      style: this.getPdfStyles().header,
      text: text,
      alignment: align,
    }
  },
  tableTotalsPane(selectedInvoice) {
    return {
      style: [this.getPdfStyles().tableStyle, this.getPdfStyles().totalsPane],
      table: {
        widths: ["40%", "*", 100, "40%"],
        body: [
          this.myCustomMarginTop(),
          [
            {
              border: [true, true, true, true],
              color,
              fillColor: store.getters.getThemeColor,
              text: `Banking Details`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [true, true, true, true],
              color,
              fillColor: store.getters.getThemeColor,
              text: `Computed Summary`,
            },
          ],
          [
            {
              border: [false, true, false, true],
              text: `Bank: ${store.getters.getUserSchool.bank}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },

            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Sub Total:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${store.getters.getCurrency} ${selectedInvoice.totalInvoiceAmount}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
          [
            {
              border: [false, true, false, true],
              text: `Account #: ${store.getters.getUserSchool.account_number}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Tax:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${store.getters.getCurrency}0`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],

          [
            {
              border: [false, true, false, true],
              text: `Type: ${store.getters.getUserSchool.account_type}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },

            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Total:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${store.getters.getCurrency} ${selectedInvoice.totalInvoiceAmount}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
        ],
      },
    };
  },
  productsHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.products}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.price}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.quantity}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  servicesHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.services}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.fee} Per ${store.getters.getCompanyLabels.duration}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        alignment: "right",
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.duration}`,
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  transportsHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.transportations}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.transportationFee} per ${store.getters.getCompanyLabels.distance}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.distance}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  itemDetails(item) {
    return [
      {
        border: [false, true, false, true],
        text: `${item.name} ${
          item.category && item.category.name
            ? "\n[" + item.category.name + "]"
            : ""
        }`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${store.getters.getCurrency}${
          item.unitPrice
            ? item.unitPrice
            : item.serviceFee
            ? item.serviceFee
            : item.transportationFee
        }`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${item.quantity ? item.quantity : item.distance}`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${store.getters.getCurrency}${item.lineTotal}`,
      },
    ];
  },
  myCustomMarginHeaderBottom() {
    return [
      { text: "\n\n", border: [false, false, false, false] },
      { text: "\n\n", border: [false, false, false, false] },
    ];
  },
  myCustomMarginTop() {
    return [
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
    ];
  },
  getPdfStyles() {
    return {
      header: {
        fontSize: 28,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      subHeader: {
        fontSize: 22,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      addressSection: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color,
        alignment: "left",
      },
      totalsPane: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color: "#000",
        alignment: "left",
      },
      fillColumns: {
        margin: [0, 10, 0, 20],
      },
      tableStyle: {
        margin: [0, 0, 0, 0],
      },
      tableMainHeaderStyle: {
        fillColor: store.getters.getThemeColor,
        border: [false, false, false, false],
      },
      email: {
        fontSize: 12,
        color: "#2196F3",
        alignment: "center",
        decoration: "underline",
        margin: [0, 0, 0, 0],
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
      paragraph: {
        fontSize: 12,
      },
      bold: {
        bold: true,
      },
      italics: {
        italics: true,
      },
      underline: {
        decoration: "underline",
      },
    };
  },
};
